export { useControleDeRespostas } from './controle-de-respostas.hook'
export * from './controle-de-respostas.interface'
